<template>
  <div class="exitMenu">
    <transition>
      <div>
        <li class="nav__item exit_item" @click="navBack"><i class="nav__item--icon"></i>
        <span class="nav__item--label">Back to main blog</span></li>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'blog-nav',
  props: {
    navs: Number,
    content: Object,
  },

  computed: {
    labels() {
      this.content.labels = "TEST";
    }
  },

  methods: {
    navBack() {
      this.$router.push('/blog')
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/BlogNav.vue